import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { DatesRangeInput } from 'semantic-ui-calendar-react'

/**
 * DateRangeFilter
 *
 * Date range picker filter using semantic-ui-calendar-react.
 */
export const DateRangeFilter = ({ value, onChange, placeholder }) => {
  const handleChange = (event, { value: newValue }) => {
    onChange(newValue.trim().replace(/-\s*$/, '').trim())
  }

  return (
    <DatesRangeInput
      name='dateRange'
      label='Value'
      placeholder={placeholder}
      value={value || ''}
      onChange={handleChange}
      iconPosition='left'
      autoComplete='off'
      dateFormat='L'
      initialDate={moment().format()}
      closable
      data-testid='marketplace-filters-date-input'
      mountNode={document.getElementById('modal-root') || document.body}
    />
  )
}

DateRangeFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
}

DateRangeFilter.defaultProps = {
  value: '',
  placeholder: 'Select date range',
}
